<template>
	<div class="body" style="position: relative">
		<div class="container">
			<div class="leftBar" style="height: 100%">
				<sidebarL
					v-if="!courseId && !barpage.includes(cocoNoteType) && !allpage.includes(cocoNoteType) "
					@getPer="getPer"
					@AddAppJson="AddAppJson"
					:get-current-url="getCurrentIframeUrl"
					ref="sidebarLRef"
				></sidebarL>
				<sidebarL2
					v-if="barpage.includes(cocoNoteType) && !allpage.includes(cocoNoteType) "
					@AddAppJson="AddAppJson"
					:cocoNoteType="cocoNoteType"
					ref="sidebarLRef"
				></sidebarL2>
			</div>
			<div class="table-container">
				<div class="top" v-show="(!appSign || cocoNoteType) && !allpage.includes(cocoNoteType) ">
					<div class="topCon">
						<div class="title"> 
							<span v-if="roleUser.orgName">{{ roleUser.orgName }}</span>
							<span style="color: #0663fe; font-weight: 600">{{
								roleUser.schoolName
							}}</span>
							<span v-if="barpage.includes(cocoNoteType)" style="color: #0663fe; font-weight: 600">
								<span v-if="cocoNoteType == 'person'">拔尖人才</span>
								<span v-if="cocoNoteType == 'classroomOb'">课堂教学评价</span>
								<span v-if="cocoNoteType == 'learning'">个性化学习中心</span>
								<span v-if="cocoNoteType == 'coconote'">跨学科学习</span>
							</span>
						</div>
						<div class="person">
              <div class="tips" v-if="['fb0cb740-5d98-11f1-9985-005056924926'].includes(roleUser.organizeid)">
                <div>{{ lang.amazonWebServices }}</div>
                <span>{{ lang.model }}：AI-ZHSZ01</span>
              </div>
							<el-badge :value="msgNum" class="item" style="margin-right: 15px;" v-show="false">
								<img src="../assets/info/tongzhi.svg" class="Msg" @click="goMsg" alt="">
							</el-badge>
							<div class="person_name" @click="editInfo">
								<img
									style="
										width: 40px;
										height: 40px;
										object-fit: cover;
										border-radius: 50%;
										cursor: pointer;
									"
									:src="
										roleUser.headportrait
											? roleUser.headportrait
											: require('../assets/img/toux2.png')
									"
									alt=""
								/>
								<div class="personInfo">
									<div class="personInfoTit">
										{{ roleUser.username }}
									</div>
									<div class="personInfoBri">
										{{ userSuffix() }}
									</div>
								</div>
							</div>
							<div v-if="prefixL != 'liyuan_' && !cocoNoteType" @click="backVersion" class="Version">
								{{ lang.Returnoldversion }}
							</div>
							<el-button
								type="text"
								@click="handleLogout"
								>{{ lang.exit }}</el-button
							>
						</div>
					</div>
				</div>

				<!-- 首页 -->
				<homepageL
					@AddAppJson="AddAppJson"
					v-show="!appSign"
					ref="homepageLRef"
				></homepageL>

				<!-- 循环数组展示iframe  -->
				<div v-for="(item, index) in AppJSon" :key="index">
					<!-- {{ item }} -->
					<!-- style="height: calc(100vh - 60px)" -->
					<div v-show="item.stateL">
						<iframe
							allow="camera *; microphone *; display-capture; midi; encrypted-media; fullscreen; geolocation; clipboard-read; clipboard-write; accelerometer; autoplay; gyroscope; payment; picture-in-picture; usb; xr-spatial-tracking;"
							frameborder="no"
							style="border: 0; width: 100%;"
							:style="{height: (cocoNoteType && !allpage.includes(cocoNoteType)) ? 'calc(100vh - 60px)' : '100vh'}"
							:src="item.json"
							:ref="item.toolId"
						>
						</iframe>
					</div>
				</div>
				<!-- 不保存缓存 -->
				<!-- style="height: calc(100vh - 60px)" -->
				<div v-if="clearifa">
					<iframe
						allow="camera *; microphone *; display-capture; midi; encrypted-media; fullscreen; geolocation; clipboard-read; clipboard-write; accelerometer; autoplay; gyroscope; payment; picture-in-picture; usb; xr-spatial-tracking;"
						frameborder="no"
						ref="clearIframeRef"
						style="border: 0; width: 100%;"
						:style="{height: (cocoNoteType && !allpage.includes(cocoNoteType)) ? 'calc(100vh - 60px)' : '100vh'}"
						:src="clearifa"
						id="clearIframeId"
					>
					</iframe>
				</div>			

				<div
					v-if="loading"
					style="
						position: absolute;
						left: 0;
						top: 0;
						width: 100%;
						height: 100%;
						background-color: #fff;
						display: flex;
						justify-content: center;
						align-items: center;
						z-index: 200;
					"
				>
					<div
						style="display: flex; flex-direction: column; align-items: center"
					>
						<img
							style="height: 75px; transform: scale(2)"
							src="../assets/img/cocoloading.gif"
							alt=""
						/>
						<div style="color: #0354d7">{{ lang.Loadingdes }}</div>
					</div>
				</div>
			</div>
			<!-- <div
				v-draggable
				class="draggable-window"
				:style="{ left: position.x + 'px', top: position.y + 'px' }"
				v-if="!appSign"
			>
				<div class="window-header" 
				@mouseenter="handleMouseEnter"
				@mouseleave="handleMouseLeave"
				>
				</div>
			</div> -->
		</div>
		<userInfoA
			ref="userInfoA"
			:userid="roleUser.userid"
			:oid="roleUser.organizeid"
			:role="roleUser.role"
			:orgName="roleUser.orgName"
		/>
    <!--    显示 AI 聊天助手（小可）-->
		<el-drawer class="dra" :visible.sync="xiaokeDia" width="100%" direction="rtl" :size="Full_Screen ? '  100%' : '30%'">
			<div slot="title" style="display: flex; align-items: center;">
				<img style="cursor: pointer;width: 24px;margin-left: 15px;" :src="!Full_Screen ? fullScreen : nofullScreen"
					@click="closeXK" alt="">
			</div>
			
			<div style="height: calc(100% - 4px);">
				<iframe width="100%" height="100%"
					allow="camera *; microphone *; display-capture; midi; encrypted-media; fullscreen; geolocation; clipboard-read; clipboard-write; accelerometer; autoplay; gyroscope; payment; picture-in-picture; usb; xr-spatial-tracking;"
					:src="linkL" 
					frameborder="0"
					scrolling="no"></iframe>
			</div>
		</el-drawer>
		<div
			v-if="lutloading"
			style="
				position: absolute;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				background-color: #fff;
				display: flex;
				justify-content: center;
				align-items: center;
				z-index: 9999;
			"
		>
			<div
				style="display: flex; flex-direction: column; align-items: center"
			>
				<img
					style="height: 75px; transform: scale(2)"
					src="../assets/img/cocoloading.gif"
					alt=""
				/>
				<div style="color: #0354d7">{{ lang.Loadingdes }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { loginOut,getCourseGroup } from "@/api/user";
import sidebarL from "../components/sidebarL.vue";
import sidebarL2 from "../components/sidebarL2.vue";

import { API_CONFIG } from "@/common/apiConfig";
import store from "../store";
import userInfoA from "../components/userInfoA.vue";
import homepageL from "./homepageL.vue";
import { myMixin } from "@/mixins/mixin.js";

export default {
	name: "HomeView",
	mixins: [myMixin],

	components: {
		sidebarL,
		sidebarL2,
		homepageL,
		userInfoA,
	},
	directives: {
		// 修改为Vue.directive的现代写法
		draggable: {
			bind(el,binding, vnode) {
				let isDragging = false; // 是否正在拖动
				let offsetX = 0; // 鼠标与元素的水平偏移
				let offsetY = 0; // 鼠标与元素的垂直偏移
				let startTime = ''

				// 鼠标按下事件
				const onMouseDown = (event) => {
					isDragging = true;
					startTime = new Date().getTime();
					offsetX = event.clientX - el.offsetLeft;
					offsetY = event.clientY - el.offsetTop;

					// 阻止选中文本
					document.body.style.userSelect = "none";

					// 绑定鼠标移动和鼠标释放事件
					document.addEventListener("mousemove", onMouseMove);
					document.addEventListener("mouseup", onMouseUp);
				};

				// 鼠标移动事件
				const onMouseMove = (event) => {
					let endTime = new Date().getTime();
					if (isDragging && (endTime - startTime > 200)) {
						// 更新元素的位置
						el.style.left = `${event.clientX - offsetX}px`;
						el.style.top = `${event.clientY - offsetY}px`;
						vnode.context.position.x = event.clientX - offsetX
						vnode.context.position.y = event.clientY - offsetY
					}
				};

				// 鼠标释放事件
				const onMouseUp = () => {
					isDragging = false;
					let endTime = new Date().getTime();
					if(endTime - startTime < 200){
						if (vnode.context && vnode.context.openxiaoKe) {
							vnode.context.openxiaoKe();
						}
					}
					document.body.style.userSelect = "";
					document.removeEventListener("mousemove", onMouseMove);
					document.removeEventListener("mouseup", onMouseUp);
				};

				// 绑定鼠标按下事件到目标元素
				el.querySelector(".window-header").addEventListener(
					"mousedown",
					onMouseDown
				);
			},
		},
	},
	data() {
		return {
			lutloading:false,
			xiaokeDia: false,
			Full_Screen:false,
			fullScreen:require('../assets/img/fullScreen.png'),
			nofullScreen:require('../assets/img/nofullScreen.png'),
			position: {
				x: window.innerWidth - 115, // 屏幕宽度减去元素宽度
				y: window.innerHeight - 150, // 屏幕高度减去元素高度
				// x: 80, // 屏幕宽度减去元素宽度
				// y: window.innerHeight - 180, // 屏幕高度减去元素高度
			}, // 初始位置
			barpage:[
				'coconote',
				'person',
				'learning',
				'classroomOb',
			], //type页面侧边栏

			allpage:['cocoflowpagey','courseopen','InterClassroom'],


			positionCopy:{},
			AppJSon: [],
			imgA: require("../assets/img/drgB.png"),
			loading: false,
			// 判断链接时beta还是cloud的
			betaL: this.$region,
			clearifa: "",
			msgNum: 0,
			cocoNoteType: this.$route.query.type,
			courseId: this.$route.query["courseid"],
			// 荔园集团下的学校
			mergedList: [
				"3823a6a5-1b6e-11f0-a66a-005056924926",
				"292e34dc-1b6e-11f0-a66a-005056924926",
				"21d6b367-1b6e-11f0-a66a-005056924926",
				"1a1a172d-1b6e-11f0-a66a-005056924926",
				"1197f86b-1b6e-11f0-a66a-005056924926",
				"f235659b-1b6d-11f0-a66a-005056924926",
				"d87b62d3-1b6d-11f0-a66a-005056924926",
				"c25ea59b-1b6d-11f0-a66a-005056924926",
			],
		};
	},
	computed: {
		...mapGetters(["userinfo", "appSign", "userinfo2","fromL"]),
		userSuffix() {
			let yym = "";
			return function () {
				// this.userinfo.role == 1 && this.userinfo.rrole == 1 && this.userinfo.type == 1 &&
				yym =
					Object.keys(this.userinfo2).length != 0
						? this.userinfo2
						: this.userinfo;

				let val = yym.accountNumber;

				let userName = JSON.parse(JSON.stringify(val));

				const regEmail = new RegExp(
					"^[A-Za-z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$"
				);

				// // 判断用户输入账户带不带后缀
				if (!regEmail.test(userName)) {
					console.log("111");
				} else {
					const parts = userName.split("@");
					userName = parts[0];
				}

				return userName;
			};
		},
		roleUser() {
			// this.userinfo.role == 1 && this.userinfo.rrole == 1 && this.userinfo.type == 1&&
			return Object.keys(this.userinfo2).length != 0
				? this.userinfo2
				: this.userinfo;
		},
		linkL(){
			// console.log('linkL',this.$region);
			if(this.$region == 'hk'){
				return 'https://aichat.cocorobo.hk/#/?id=335951a7-65ec-40e9-ae91-2971464ade4e&type=agent'
			}else if(this.$region == 'cn'){
				return 'https://aichat.cocorobo.cn/#/?id=335951a7-65ec-40e9-ae91-2971464ade4e&type=agent'
			}else if(this.$region == 'com'){
				return 'https://aichat.cocorobo.com/#/?id=335951a7-65ec-40e9-ae91-2971464ade4e&type=agent'
			}else{
				return 'https://aichat.cocorobo.cn/#/?id=335951a7-65ec-40e9-ae91-2971464ade4e&type=agent'
			}
			// return this.$region == 'hk'
			// ? 'https://aichat.cocorobo.hk/#/?id=335951a7-65ec-40e9-ae91-2971464ade4e&type=agent'
			// : 'https://aichat.cocorobo.cn/#/?id=335951a7-65ec-40e9-ae91-2971464ade4e&type=agent'
		}
	},
	watch: {
		clearifa(newVal) {
			if (newVal) {
				// 当 clearifa 变化时，等待 DOM 更新后设置监听器
				this.$nextTick(() => {
					if (this.$refs.clearIframeRef && !this.$refs.clearIframeRef.hasLoadListener) {
						this.$refs.clearIframeRef.addEventListener('load', this.handleLoad);
						this.$refs.clearIframeRef.hasLoadListener = true;
					}
				});
			}
		},
		// 监听路由 query 参数变化，当组件复用时触发
		'$route.query'(newQuery, oldQuery) {
			// 当 courseid 或 type 变化时，重新初始化
			const oldCourseId = oldQuery && oldQuery.courseid;
			const oldType = oldQuery && oldQuery.type;
			if (newQuery.courseid !== oldCourseId || newQuery.type !== oldType) {
				this.initRouteData();
			}
		},
		'roleUser.userid'(val) {
			if (val) this.openCszyAIPopCourse()
		}
	},
	methods: {
		...mapActions({
			logout: "user/logout",
		}),
		// 子组件通过 :get-current-url 调用，可拿到返回值 { url, hash }
		getCurrentIframeUrl() {
			const iframe = document.getElementById('clearIframeId');
			if (!iframe) return '';

			let url = '';
			// 同源时可读到 iframe 内部跳转后的 location；跨域会抛异常，自动降级用 src
			try {
				url = iframe.contentWindow && iframe.contentWindow.location
					? iframe.contentWindow.location.href
					: '';
			} catch (e) {
				url = '';
			}

			if (!url) url = iframe.src || '';

			const match = url.match(/#\/([^?/]+)/);
			return (match && match[1]) ? match[1] : '';
		},
		// 初始化路由数据（从 mounted 中提取，用于路由参数变化时重新执行）
		initRouteData() {
			console.log("重新获取数据", this.lang.lang);
			
			let page1 = this.getUrlParam(window.parent.location.href, 'type');
			let page2 = this.getUrlParam(window.parent.location.href, 'courseid');

			if (page1) {
				this.cocoNoteType = page1
				this.courseId = page2
			} else {
				// 如果 window.parent 没有参数，则从路由 query 获取
				this.courseId = this.$route.query.courseid
				this.cocoNoteType = this.$route.query.type
			}

			console.log('this.courseId', this.courseId);
			console.log('this.cocoNoteType', this.cocoNoteType);
			let cocoflowpage = ['cocoflow1','cocoflow3',...this.barpage,...this.allpage]


			
			// 防止乱输入type展示出侧边栏与学生不能使用type进入课堂观察
			if (!cocoflowpage.includes(this.cocoNoteType) || (this.cocoNoteType == 'classroomOb' && this.roleUser.type == 2)) {
				this.cocoNoteType = ''
			}
			
			if (
				!this.roleUser.cclassid &&
				this.roleUser.type == 1 &&
				!this.roleUser.rrole &&
				Object.keys(this.userinfo2).length == 0 &&
				this.mergedList.includes(this.roleUser.org)
			) {
				this.editInfo();
			}
			
			// 跨学科app跳转 
			if(this.cocoNoteType === 'coconote'){
				this.cocoNoteif()
				return
			}else if (this.cocoNoteType === 'person') {
				this.openApp2({
					stateL: true,
					toolId: "topTalent",
				});
				return
			}else if (this.cocoNoteType === 'classroomOb') {
				if (this.roleUser.type == 1) {
					this.openApp2({
						stateL: true,
						toolId: "classroomObservation",
					});
				}
				return
			}else if (this.cocoNoteType === 'learning') {
				if (this.roleUser.type == 1) {
					this.openApp2({
						stateL: true,
						toolId: "learning",
					});
				}else {
					this.openApp2({
						stateL: true,
						toolId: "learning/studentProjectList",
					});
				}
				
				return
			} else if (this.cocoNoteType === 'cocoflow1') {
				this.openApp2({
					stateL: true,
					toolId: "cocoflow1",
				});
				return
			} else if (this.cocoNoteType === 'cocoflow3') {
				this.openApp2({
					stateL: true,
					toolId: "cocoflow3",
				});
				return
			} else if (this.cocoNoteType === 'courseopen') {
				this.openApp2({
					stateL: true,
					toolId: "course",
				});
				return
			} else if (this.cocoNoteType === 'InterClassroom') {
				this.openApp2({
					stateL: true,
					toolId: "pptEasy",
				});
				return
			} else if (this.cocoNoteType === 'cocoflowpagey') {
				this.openApp2({
					stateL: true,
					toolId: "appStore",
				});
				return
			} else if (this.courseId) {
				console.log('ok了');
				// 随机码登录跳转
				this.openApp2({
					stateL: true,
					toolId: "courseDetail",
				});
				return
			}
			this.getPer();
			
			// 使用 document.ready 方法监听 iframe 加载
			this.setupIframeLoadListeners();
		},
		// 设置 iframe load 事件监听器的辅助方法
		setupIframeLoadListener(toolId) {
			if (toolId && this.$refs[toolId]) {
				const iframeRefs = Array.isArray(this.$refs[toolId]) 
					? this.$refs[toolId] 
					: [this.$refs[toolId]];
				iframeRefs.forEach((iframe) => {
					if (iframe && !iframe.hasLoadListener) {
						iframe.addEventListener('load', this.handleLoad);
						iframe.hasLoadListener = true;
					}
				});
			}
		},
		// 设置所有 iframe 的 load 事件监听器
		setupIframeLoadListeners() {
			const setupListeners = () => {
				// 为循环中的 iframe 添加 load 事件监听器
				if (this.AppJSon && this.AppJSon.length > 0) {
					this.AppJSon.forEach((item) => {
						if (item.toolId) {
							this.setupIframeLoadListener(item.toolId);
						}
					});
				}
				// 为 clearIframeRef 添加 load 事件监听器
				if (this.$refs.clearIframeRef) {
					if (!this.$refs.clearIframeRef.hasLoadListener) {
						this.$refs.clearIframeRef.addEventListener('load', this.handleLoad);
						this.$refs.clearIframeRef.hasLoadListener = true;
					}
				}
			};
			
			// 使用 document.ready (DOMContentLoaded)
			if (document.readyState === 'loading') {
				document.addEventListener('DOMContentLoaded', setupListeners);
			} else {
				// DOM 已经加载完成
				this.$nextTick(setupListeners);
			}
		},
		handleMouseEnter() {
			const element = document.querySelector('.window-header');
			if (element && this.lang.lang == 'cn') {
				element.style.backgroundImage = `url(${require('../assets/img/drgB.png')})`;
			}else if(this.lang.lang == 'hk'){
				element.style.backgroundImage = `url(${require('../assets/img/drahk.png')})`;
			}else{
				element.style.backgroundImage = `url(${require('../assets/img/draen.png')})`;
			}
			
		},
		handleMouseLeave() {
			const element = document.querySelector('.window-header');
			if (element) {
				element.style.backgroundImage = `url(${require('../assets/img/drgA.png')})`;
			}
		},
		openxiaoKe(){
			// console.log('666');
			this.positionCopy = JSON.parse(JSON.stringify(this.position))
			this.xiaokeDia = true;
		},
		closeXK(){
			this.Full_Screen = false
			this.position = JSON.parse(JSON.stringify(this.positionCopy))

		},
		setHovered(val) {
			if (val) {
				this.imgA = require("../assets/img/drgA.png");
			} else {
				this.imgA = require("../assets/img/drgB.png");
			}
		},
		async cocoNoteif(){
			// 随机码登录跳转
			this.openApp2({
				stateL: true,
				toolId: "synergyCourse",
			});

			if (this.cocoNoteType && this.courseId) {
				if (this.roleUser.role==1) {
					window.topU.postMessage(
						{
							tools: "opencCscl2",
							cid: this.courseId,
							gid: '',
						},
						"*"
					);
					this.addOp3('1', "", { courseid: this.courseId , type: "CocoNote_open" }, "success")
					return;
				}

				let params = {
					cid: this.courseId,
					classid: '1',
				};
				
				try {
					let res = await getCourseGroup(params);
					if (res.data && res.data[1].length) {
						let groupPerson = res.data[1]
						let groupCid = ''
						for (var i = 0; i < groupPerson.length; i++) {
							if (groupPerson[i].userid == this.roleUser.userid) {
								groupCid = groupPerson[i].groupCid
								break;
							}
						}
						if (groupCid) {
							window.topU.postMessage(
								{
									tools: "opencCscl2",
									cid: this.courseId,
									gid: groupCid,
								},
								"*"
							);
							this.addOp3('1', "", { courseid: this.courseId , type: (this.roleUser.type == 1 ? '_teacher' : '_student') +  "CocoNote_open" }, "success")
						} else {
							this.$message.error("没有加入分组请先加入分组");
							this.openApp2({
								stateL: true,
								toolId: "synergyCourse/add",
							});
							this.addOp3('1', "", { courseid: this.courseId , type:  (this.roleUser.type == 1 ? '_teacher' : '_student') +  "CocoNote_open" }, '没有加入分组请先加入分组')
						}
					} else {
						console.log('888');

						this.$message.error("没有加入分组请先加入分组");
						this.openApp2({
							stateL: true,
							toolId: "synergyCourse/add",
						});
						this.addOp3('1', "", { courseid: this.courseId , type:  (this.roleUser.type == 1 ? '_teacher' : '_student') +  "CocoNote_open" }, '没有加入分组请先加入分组')
					}
				} catch (error) {
					this.addOp3(
						"1",
						"",
						{ courseid: this.courseId ,type:  (this.roleUser.type == 1 ? '_teacher' : '_student') +  "CocoNote_open" },
						error
					)
				}	
			}
		},
		// 跳转
		async goMsg(){
				console.log('去通知页');
				// noticeCenter?
				let url = ''
				if (this.$region == 'beta') {
                    url = `https://beta.pbl.cocorobo.cn/pbl-teacher-table/dist/#/noticeCenter?userid=${this.roleUser.userid}&oid=${this.roleUser.organizeid}&org=${this.roleUser.org}`
                }else{
                    url = `https://pbl.cocorobo.cn/pbl-teacher-table/dist/#/noticeCenter?userid=${this.roleUser.userid}&oid=${this.roleUser.organizeid}&org=${this.roleUser.org}`
                }

				let pl = {json:url ,stateL :true,toolId :'noticeCenter'}
                await store.commit('user/SET_AppSIGN', 'noticeCenter')

                // 添加打开应用
                this.AddAppJson(pl)
                this.addOp3('1', "", { type:this.prefixL + 'noticeCenter' + "_open" }, "success")
		},
		// 打开编辑弹框
		editInfo() {
			this.$refs.userInfoA.openDig();
		},
		// 返回旧版本
		backVersion(){
			this.$confirm(this.lang.backoldversion, this.lang.tip, {
				confirmButtonText: this.lang.confirm,
				cancelButtonText: this.lang.Cancel,
				type: "warning",
			})
			.then(() => {
				console.log(this.$region);
				if (this.$region == 'beta') {
					window.topU.location.href = 'https://beta.cloud.cocorobo.cn/index.html'
				}else if(this.$region == 'hk'){
					window.topU.location.href = 'https://cloud.cocorobo.hk/index.html'
				}else if(this.$region == 'com'){
					window.topU.location.href = 'https://cloud.cocorobo.com/index.html'
				}else{
					window.topU.location.href = 'https://cloud.cocorobo.cn/index.html'
				}
			})
			.catch(() => {});
		},
		getMsg(){
			let params = [
				{
					functionName: API_CONFIG.ajax_selectnotNum.functionName, // 调用存储过程的名称
					uid: this.roleUser.userid, 
					status: 0,  //1已读 0是未读
				},
			];  
			// 获取学校权限与组织权限,优先使用学校权限,其次使用组织权限
			// 第一步
			this.$ajax.post(API_CONFIG.baseUrl, params)
			.then(res=>{
				console.log(res.data[0]);
				let data = res.data[0]
				this.msgNum = data[0].num

			})
			.catch(() => {
				// 取消操作
			});
		},
		// 打开平台应用工具
		AddAppJson(val) {
			// this.getMsg()
			console.log("AddAppJson", val);

			// 单独为拔尖人才设置的，防止清空gotype后无法返回
			const url = val.json;
			const match = url.match(/#\/([^?]+)/);
			if (match && match[1] && match[1] == 'topTalent') {
				if (window.topU) {
					window.topU.gotype = '/topTalent'
				}
			}

			// 学生跳转课程中心需要改变一下参数
			if(val.toolId == 'study' && this.roleUser.type == 2){
				val.json = val.json.replace(/([?&])classId=([^&]*)/, '$1cid=$2');
			} else if(val.toolId == 'futureClassType'){
				val.json = val.json + '&person=person';
			} else if(val.toolId == 'classroomOb'){
				val.json = val.json + '&showIntroduceType=1';
			}

			// 荔园首页工具切换，不缓存工具
			if (val.clearL || val.toolId == "cocobookllm") {
				this.loading = true;
				this.AppJSon.forEach((e) => {
					this.$set(e, "stateL", false); // 使用 Vue.set 确保响应式
				});
				this.clearifa = val.json;
				return;
			}

			// 判断有没有打开过这个应用
			let data = this.AppJSon.filter((e) => {
				return val.toolId == e.toolId;
			});

			//为0则添加进列表,并将其他的展示状态改为false
			if (data.length == 0) {
				this.loading = true;
				this.AppJSon.forEach((e) => {
					this.$set(e, "stateL", false); // 使用 Vue.set 确保响应式
				});
				this.AppJSon.push(val);
				// 为动态添加的 iframe 添加 load 事件监听器
				this.$nextTick(() => {
					this.setupIframeLoadListener(val.toolId);
				});
			} else {
				this.AppJSon.forEach((e) => {
					if (val.toolId == e.toolId) {
						//已经打开过了,将点击的工具展示状态改为false
						this.$set(e, "stateL", true); // 使用 Vue.set 确保响应式
					} else {
						this.$set(e, "stateL", false); // 确保响应式更新
					}
				});
				setTimeout(() => {
					// console.log('this.$refs.appRef.contentWindow.document.body;', this.$refs[val.toolId][0].contentWindow.document.body);
					this.loading = false;
					if (!this.$refs[val.toolId][0].contentWindow.document.body) {
						this.$refs[val.toolId][0].contentWindow.location.reload();
					}
				}, 2000);
			}
		},
		// iframe加载完成
		async handleLoad(){
			this.loading = false;
			console.log('iframe加载完成');
		},
		async handleLogout() {
			this.$confirm(this.lang.sureexit, this.lang.tip, {
				confirmButtonText: this.lang.confirm,
				cancelButtonText: this.lang.Cancel,
				type: "warning",
			})
				.then(async () => {
					this.lutloading = true;
					loginOut()
						.then(async () => {
							this.$message({
								message: this.lang.Exitsu,
								type: "success",
							});
							await this.logout();
							this.lutloading = false;

							// this.$router.push("/login");
						})
						.catch((err) => {
							console.error(err);
						});
				})
				.catch(() => {
					// 取消操作
				});
		},
		// 生成学生跳转到课程详情的链接
		async openApp2(val) {
			let url = '';
			let argumentList = ["courseId","userid", "oid", "org","role","cid","tType","screenType"];
			let teabeta = 'https://beta.pbl.cocorobo.cn/pbl-teacher-table/dist/#/'
			let teacn = 'https://pbl.cocorobo.cn/pbl-teacher-table/dist/#/'
			let teahk = 'https://pbl.cocorobo.hk/pbl-teacher-table/dist/#/'
			let teacom = 'https://pbl.cocorobo.com/pbl-teacher-table/dist/#/'

			let stubeta = 'https://beta.pbl.cocorobo.cn/pbl-student-table/dist/#/'
			let stucn = 'https://pbl.cocorobo.cn/pbl-student-table/dist/#/'
			let stuhk = 'https://pbl.cocorobo.hk/pbl-student-table/dist/#/'
			let stucom = 'https://pbl.cocorobo.com/pbl-student-table/dist/#/'

			let appbeta = 'https://beta.app.cocorobo.cn/#/'
			let appcom = 'https://app.cocorobo.cn/#/'
			let apphk = 'https://app.cocorobo.hk/#/'
			let appcn = 'https://app.cocorobo.cn/#/'

			let teaPage = ['synergyCourse','synergyCourse/add','topTalent','classroomObservation','course','pptEasy']
			let stuPage = ['courseDetail']
			let apppage = ['learning','learning/studentProjectList','appStore']
			let cocoflowpage = ['cocoflow1','cocoflow3']


			if (this.$region == "beta") {
				if (stuPage.includes(val.toolId)) {
					url =stubeta + val.toolId;	
				} else if(teaPage.includes(val.toolId)){
					url =teabeta + val.toolId;
				} else if (apppage.includes(val.toolId)) {
					if (this.cocoNoteType == 'cocoflowpagey') {
						url = appbeta
					}else{
						url = appbeta + val.toolId;
					}
				} else if (cocoflowpage.includes(val.toolId)) {
					url = appbeta + 'workSpace';
				}
			} else if (this.$region == "hk") {
				if (stuPage.includes(val.toolId)) {
					url = stuhk+ val.toolId;
				} else if(teaPage.includes(val.toolId)){
					url =teahk + val.toolId;
				} else if (apppage.includes(val.toolId)) {
					if (this.cocoNoteType == 'cocoflowpagey') {
						url = apphk
					}else{
						url = apphk + val.toolId;
					}
				} else if (cocoflowpage.includes(val.toolId)) {
					url = apphk + 'workSpace';
				}
			} else if (this.$region == "com") {
				if (stuPage.includes(val.toolId)) {
					url = stucom + val.toolId;
				} else if(teaPage.includes(val.toolId)){
					url =teacom + val.toolId;
				} else if (apppage.includes(val.toolId)) {
					if (this.cocoNoteType == 'cocoflowpagey') {
						url = appcom
					}else{
						url = appcom + val.toolId;
					}
				} else if (cocoflowpage.includes(val.toolId)) {
					url = appcom + 'workSpace';
				}
			}else{
				if (stuPage.includes(val.toolId)) {
					url = stucn + val.toolId;
				}else if(teaPage.includes(val.toolId)){
					url =teacn + val.toolId;
				} else if (apppage.includes(val.toolId)) {
					if (this.cocoNoteType == 'cocoflowpagey') {
						url = appcn
					}else{
						url = appcn + val.toolId;
					}
				} else if (cocoflowpage.includes(val.toolId)) {
					url = appcn + 'workSpace';
				}
			}

			await store.commit("user/SET_AppSIGN", val.toolId);

			let _userinfo = this.roleUser, //登录用户信息
				{
					userid: _userid,
					organizeid: _oid,
					org: _org,
					role: _role,
					classid: _classid,
				} = _userinfo; // 解构赋值获取用户信息
			let queryString = "";
			if (argumentList && argumentList.length) {

				let paramsMap = ''
				if (val.toolId == 'courseDetail') {
					paramsMap = {
						courseId: this.courseId,
						userid: _userid,
						oid: _oid,
						org: _org,
						cid: _classid,
						tType: this.roleUser.type,
						screenType :2
					};
				}else if (val.toolId == 'synergyCourse') {
					paramsMap = {
						userid: _userid,
						oid: _oid,
						org: _org,
						role: _role,
						ly :1
					};
				}else if (val.toolId == 'synergyCourse/add') {
					paramsMap = {
						cid: this.courseId,
						userid: _userid,
						oid: _oid,
						org: _org,
						role: _role,
						ly :1
					};
				}else if (val.toolId == 'topTalent') {
					paramsMap = {
						userid: _userid,
						oid: _oid,
						org: _org,
						role: _role,
						tType: this.roleUser.type,
					};
				}else if (val.toolId == 'learning') {
					paramsMap = {
						userid: _userid,
						oid: _oid,
						org: _org,
						role: _role,
					};
				}else if (val.toolId == 'classroomObservation') {
					paramsMap = {
						userid: _userid,
						oid: _oid,
						org: _org,
					};
				}else if (val.toolId == 'course') {
					paramsMap = {
						userid:_userid,
						oid: _oid,
						org: _org,
						role:_role
					};
				}else if (val.toolId == 'pptEasy') {
					paramsMap = {
						userid: _userid,
						oid: _oid,
						org: _org,
						role: _role,
					};
				}else if (val.toolId == 'appStore') {
					paramsMap = {
						userid: _userid,
						oid: _oid,
						org: _org,
						role: _role,
					};
				}
				console.log('paramsMap',paramsMap);
				console.log('val.toolId',val.toolId);

				const canshu = argumentList
					.filter((param) => paramsMap[param] !== undefined || param === "type")
					.map((param) =>
						param === "type"
							? `tType=${paramsMap["tType"]}`
							: `${param}=${paramsMap[param]}`
					);

				queryString = canshu.length
					? (url.includes("?") ? "&" : "?") + canshu.join("&")
					: ""; // 生成查询字符串
			}
			console.log('queryString',queryString);
			
			let _url = ''
			if (val.toolId == 'synergyCourse' || val.toolId == 'synergyCourse/add') {
				_url = url + queryString + '&person=person';
			}else if (val.toolId == 'classroomObservation') {
				_url = url + queryString + '&showIntroduceType=1';
			}else if (val.toolId == 'study' && this.roleUser.type == 2) {
                _url = _url.replace(/([?&])classId=([^&]*)/, '$1cid=$2');
			} else if (val.toolId == 'cocoflow1') {
				_url = url + '?tab=1&checkMode=1';
			} else if (val.toolId == 'cocoflow3') {
				_url = url + '?tab=1&checkMode=3';
			} else {
				_url = url + queryString;
			}
			console.log("_url", _url);

			let pl = {
				json: _url,
				stateL: true,
				toolId: val.toolId,
				// clearL: val.clearL,
			};
			this.AddAppJson(pl)
			// this.$emit("cutUrl", pl);
			// this.addOp3(
			// 	"1",
			// 	"",
			// 	{ type: this.prefixL + val.toolId + (this.roleUser.type == 1 ? '_teacher' : '_student') +  "stu_open" },
			// 	"success"
			// );
		},
		// 获取学校权限与组织权限,优先使用学校权限,其次使用组织权限
		async getPer() {
			this.clearifa = "";
			// 查询首页应用
			// this.$refs.homepageLRef.getData();
			//查询cocofrow最近使用与收藏
			if (this.roleUser.type == 1) {
				this.$refs.sidebarLRef.getData();
			}

			// fromL 的初始值如下，判断其内容是否被修改可根据 basics、desktop.list、admin.index.list、admin.sidebar.list 是否有实际数据
			const fromL = this.fromL;
			const hasFromLData =
				(fromL &&
					(
						fromL.basics.title ||
						fromL.basics.brief ||
						fromL.basics.logo ||
						(fromL.desktop && fromL.desktop.list && fromL.desktop.list.length > 0) ||
						(fromL.admin && fromL.admin.index && fromL.admin.index.list && fromL.admin.index.list.length > 0) ||
						(fromL.admin && fromL.admin.index && fromL.admin.index.stuList && fromL.admin.index.stuList.length > 0) ||
						(fromL.admin && fromL.admin.sidebar && fromL.admin.sidebar.list && fromL.admin.sidebar.list.length > 0) ||
						(fromL.admin && fromL.admin.sidebar && fromL.admin.sidebar.stuList && fromL.admin.sidebar.stuList.length > 0)
					)
				) ? true : false;

			if (!hasFromLData) {
				await store.dispatch('user/getschPerInfo')
			}
			// await store.commit("user/SET_FROM", perData);
			// 获取后台管理设置常见应用
			this.$refs.homepageLRef.getadmincocoFlow();
			this.loading = false;
			this.openCszyAIPopCourse();
		},
		isCszyOrg() {
			const user = this.roleUser || {}
			const orgId = '8fc840b2-6f83-11f1-9985-005056924926'
			return user.organizeid == orgId
		},
		openCszyAIPopCourse() {
			const user = this.roleUser || {}
			if (user.type != 1 || !this.isCszyOrg() || !user.userid) return
			if (this.courseId || this.cocoNoteType) return
			if (this.AppJSon.some((e) => e.toolId == 'cszyAIPopCourse')) return

			// let host = ''
			// if (this.$region == 'hk') host = 'https://cloud.cocorobo.hk'
			// else if (this.$region == 'com') host = 'https://cloud.cocorobo.com'
			// else if (this.$region == 'beta') host = 'https://beta.cloud.cocorobo.cn'

			store.commit('user/SET_AppSIGN', 'cszyAIPopCourse')
			this.AddAppJson({
				json: `https://cloud.cocorobo.cn/ai.html?gotype=cszy&userid=${user.userid}`,
				stateL: true,
				toolId: 'cszyAIPopCourse'
			})
		},
		getUrlParam(urlStr, urlKey) {
			const url = new URL(urlStr) // 字符串转换成url格式
			const paramsStr = url.search.slice(1) // 获取'?'后面的参数字符串
			const paramsArr = paramsStr.split('&') // 分割'&'字符 获得参数数组
			for (let i = 0; i < paramsArr.length; i++) {
				const tempArr = paramsArr[i].split('=')
				if (tempArr[0] === urlKey) {
					return tempArr[1]
				}
			}
		},
	},
	mounted() {
		// 初始化路由数据
		this.initRouteData();
		this.openCszyAIPopCourse();
	},
};
</script>

<style scoped>
.top {
	width: 100%;
	padding: 0 90px;
	display: flex;
	height: 60px;
	box-sizing: border-box;
}

.topCon {
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
}

.body {
	width: 100%;
	height: 100%;
	overflow: hidden;
	font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
		"Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.title {
	font-family: PingFang SC;
	font-weight: 400;
	font-size: 14px;
	line-height: 100%;
	letter-spacing: 0%;
	color: #969ba3;
	display: flex;
	gap: 11px;
}

.person {
	display: flex;
	align-items: center;
	gap: 15px;
}

.tips {
	display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
	gap: .5rem;
  font-size: .875rem;
}

.person_name {
	display: flex;
	gap: 9px;
}

.personInfo {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 5px 0 2px;
	box-sizing: border-box;
}

.personInfoTit {
	font-family: PingFang SC;
	font-weight: 500;
	font-size: 14px;
	line-height: 100%;
	color: #000000;
}

.personInfoBri {
	font-family: PingFang SC;
	font-weight: 300;
	font-size: 10px;
	line-height: 100%;
	color: #969ba3;
}

.container {
	display: flex;
	width: 100%;
	height: 100vh;
}

.container >>> .el-loading-mask {
	z-index: 0;
}

.table-container {
	/* display: flex;
  flex: 1;
  justify-content: center; */
	width: 100%;
	background-color: #f9fafb;
	position: relative;
}

.leftBar {
	/* box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px 6px rgb(0 0 0 / 0.1); */
	/* overflow: visible;  */
	z-index: 999;
}

.Version{
	background: #f0f4fa;
	border-radius: 50px 50px 50px 50px;
	/* position: absolute; */
	color: #060e17;
	padding: 8px 10px;
	font-size: 14px;
	box-sizing: border-box;
	/* right: 0; */
	cursor: pointer;
}
.Msg{
	cursor: pointer;
	height: 25px;
}
.draggable-window {
	position: absolute;
	cursor: pointer;
	z-index: 999;
}
.dra >>> .el-drawer__header{
	padding: 20px 20px 0 0 !important;
}
.window-header {
	height: 88px;
	width: 105px;
	cursor: pointer;
	background: url('../assets/img/drgA.png') no-repeat center center;
	background-size: cover;
}
/* .window-header:hover {
	height: 88px;
	width:105px;
	cursor: pointer;
	background: url('../assets/img/drgB.png') no-repeat center center;
	background-size: cover;
} */
</style>
